import * as React from "react";
import { ReviewTileItem } from "@/types/tile.types";
import { getTileContentAsText } from "@/utils/tile.utils";

interface UseAddAllAsCommentsProps {
  onComplete?: (result: { success: number; failed: number }) => void;
  onError?: (error: string) => void;
}

export const useAddAllAsComments = ({ onComplete, onError }: UseAddAllAsCommentsProps) => {
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [progress, setProgress] = React.useState({ completed: 0, total: 0 });

  const addAllAsComments = async (items: ReviewTileItem[]) => {
    setIsProcessing(true);
    setProgress({ completed: 0, total: items.length });

    let successCount = 0;
    let failedCount = 0;

    try {
      for (const [index, item] of items.entries()) {
        try {
          await Word.run(async (context) => {
            const tileText = getTileContentAsText(item);
            const selection = context.document.getSelection();
            selection.insertComment(tileText);
          });
          successCount++;
        } catch (error) {
          console.error("Error adding comment for tile:", item, error);
          failedCount++;
        }
        setProgress({ completed: index + 1, total: items.length });
      }

      onComplete?.({ success: successCount, failed: failedCount });
    } catch (error) {
      console.error("Error in bulk add comments:", error);
      onError?.((error as Error).message);
    } finally {
      setIsProcessing(false);
    }
  };

  return { isProcessing, progress, addAllAsComments };
};
